import { MeterView } from './MeterView';
import { ViewsRepository } from '@Engage.Data/repositories/views/ViewsRepository';
import { CookiesStorageService } from '@Engage.Data.Services';
import { localStorageService } from '@Engage.Data/services/storage/localStorage/LocalStorageService';
import { StorageKeys, MeteredArticleCountObj, ConvoArticleCountObj } from '@Engage.Data.Constants';
const isEmptyObj = (obj) => !obj || (typeof obj === 'object' && Object.keys(obj).length === 0);
const LAST_RESET_DATE_KEY = 'nxt_last_reset_date';
const USER_SESSION_KEY = 'nxt_user_sessions';
export class ViewData {
    constructor() {
        this._viewStructureCache = null;
        this._userSessionsCache = null;
    }
    async createViews() {
        const localStoredViews = this.getViewStructure();
        if (!isEmptyObj(localStoredViews)) {
            return this.createCookieViews(localStoredViews);
        }
        try {
            const successData = await ViewsRepository.getViews();
            return successData ? this.createViewsFromApi(successData) : [];
        }
        catch (error) {
            console.error('[ViewData] getApiView error', error);
            return [];
        }
    }
    createViewsFromApi(successData) {
        try {
            const meterViews = [];
            if (!isEmptyObj(successData.DynamicMeterViews)) {
                Object.keys(successData.DynamicMeterViews).forEach(meterKey => {
                    const levelData = successData.DynamicMeterViews[meterKey];
                    if (levelData)
                        meterViews.push(new MeterView(meterKey, levelData));
                });
            }
            this.saveLastResetDate(successData.LastResetDate);
            this.saveUserSessions(successData.UserStorageSession);
            return meterViews;
        }
        catch (ex) {
            console.error('[ViewData] createViewsFromApi error', ex);
            return [new MeterView(-1, {})];
        }
    }
    createCookieViews(cookieViews) {
        if (isEmptyObj(cookieViews))
            return [];
        return Object.keys(cookieViews)
            .filter(meterLevel => !!cookieViews[meterLevel])
            .map(meterLevel => {
            const meterCookie = cookieViews[meterLevel];
            return new MeterView(meterLevel, {
                ActiveConversationCode: meterCookie[MeteredArticleCountObj.ActiveConvoCode] || null,
                ArticleCount: meterCookie['_ac'],
                DeviceArticleCount: meterCookie['_ac_d'],
                Conversations: this.getConversationsFromCookie(meterCookie)
            });
        });
    }
    getConversationsFromCookie(meterCookie) {
        const conversations = [];
        const activeConvoCode = meterCookie[MeteredArticleCountObj.ActiveConvoCode];
        Object.keys(meterCookie).forEach((code) => {
            const convo = meterCookie[code];
            if (!code || code.startsWith('_') || typeof convo !== 'object')
                return;
            if (/^\d+$/.test(code) && code !== activeConvoCode)
                return;
            conversations.push({
                Code: code,
                Id: 0,
                ViewCount: convo[ConvoArticleCountObj.ArticleCount] || 0,
                DeviceViewCount: convo[ConvoArticleCountObj.DeviceArticleCount] || 0,
                StartDate: convo[ConvoArticleCountObj.StartDate],
                FreeArticlesRemaining: convo['far'] || 0,
                freeArticlesRepeatable: convo['frp'] || []
            });
        });
        return conversations;
    }
    // ─── Storage helpers ──────────────────────────────────────────────────────
    getViewStructure() {
        if (this._viewStructureCache !== null)
            return this._viewStructureCache;
        try {
            const raw = CookiesStorageService.get(StorageKeys.ConnextViewStructure, {
                isSecureValue: false,
                useRootDomain: false
            });
            this._viewStructureCache = raw ? JSON.parse(raw) : {};
            return this._viewStructureCache;
        }
        catch (_a) {
            return {};
        }
    }
    setViewStructure(data) {
        this._viewStructureCache = data;
        CookiesStorageService.set(StorageKeys.ConnextViewStructure, JSON.stringify(data), {
            daysOfLife: 365,
            useRootDomain: false
        });
    }
    getViewedArticles() {
        return localStorageService.get(StorageKeys.ViewedArticles, { expandKey: false });
    }
    setViewedArticles(articles) {
        localStorageService.set(StorageKeys.ViewedArticles, articles, { expandKey: false });
    }
    deleteViewedArticles() {
        localStorageService.delete(StorageKeys.ViewedArticles, { expandKey: false });
    }
    saveLastResetDate(date) {
        if (date)
            localStorageService.set(LAST_RESET_DATE_KEY, date, { expandKey: false });
    }
    getLastResetDate() {
        var _a;
        return (_a = localStorageService.get(LAST_RESET_DATE_KEY, { expandKey: false })) !== null && _a !== void 0 ? _a : '';
    }
    saveUserSessions(sessions) {
        if (!(sessions === null || sessions === void 0 ? void 0 : sessions.length))
            return;
        try {
            this._userSessionsCache = sessions;
            localStorageService.set(USER_SESSION_KEY, JSON.stringify(sessions), { expandKey: false });
        }
        catch (_a) { }
    }
    getUserSessions() {
        if (this._userSessionsCache !== null)
            return this._userSessionsCache;
        try {
            const raw = localStorageService.get(USER_SESSION_KEY, { expandKey: false });
            this._userSessionsCache = raw ? JSON.parse(raw) : [];
            return this._userSessionsCache;
        }
        catch (_a) {
            return [];
        }
    }
}
